module.exports = __webpack_public_path__ + "static/media/rank-3.f48d9f95.svg";